"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var html_definitions_1 = require("./html-definitions");
var PrintSettingsComponent = /** @class */ (function () {
    function PrintSettingsComponent() {
        var _this = this;
        this.view =
            window.rslidy.utils.prependHtmlString(document.body, html_definitions_1.print_settings_html);
        // apply print settings whenever changed, in case the user wants
        // to preview it on firefox
        var inputs = this.view.getElementsByTagName("input");
        for (var i = 0; i < inputs.length; i++) {
            inputs[i].onchange = function () { return _this.applyPrintSettings(); };
        }
        this.view
            .querySelector("#rslidy-checkbox-link")
            .addEventListener("click", function (e) { return window.rslidy.toolbar.closeMenuOnSelection(); });
        this.view
            .querySelector("#rslidy-checkbox-snum")
            .addEventListener("click", function (e) { return window.rslidy.toolbar.closeMenuOnSelection(); });
        this.view
            .querySelector("#rslidy-checkbox-frame")
            .addEventListener("click", function (e) { return window.rslidy.toolbar.closeMenuOnSelection(); });
        this.view
            .querySelector("#rslidy-button-print-submit")
            .addEventListener("click", function (e) { return _this.print(); });
        this.applyPrintSettings();
    }
    // ---
    // Description: Set the CSS from print settings
    // ---
    PrintSettingsComponent.prototype.applyPrintSettings = function () {
        // remove old settings
        if (this.style)
            document.getElementsByTagName('head')[0].removeChild(this.style);
        var link = (this.view.querySelector("#rslidy-checkbox-link"));
        var snum = (this.view.querySelector("#rslidy-checkbox-snum"));
        var frame = (this.view.querySelector("#rslidy-checkbox-frame"));
        var css = "@media print {\n";
        if (!link.checked) {
            css += "a[href^=\"http://\"]:after, a[href^=\"https://\"]:after {\n        content: \"\" !important;\n      }";
        }
        if (snum.checked) {
            css += "#rslidy-content-section {\n        counter-reset: slide-counter;\n      }\n      #rslidy-content-section .slide:after {\n        content: counter(slide-counter);\n        counter-increment: slide-counter;\n        position: absolute;\n        right: 0.8rem;\n        bottom: 0.8rem;\n        font: 60% Sans-Serif;\n      }";
        }
        if (frame.checked) {
            css += ".slide {\n        border: " + window.rslidy.print_frame + ";\n      }";
        }
        css += "\n}";
        // inject CSS
        var style = document.createElement('style');
        style.type = 'text/css';
        style.innerHTML = css;
        document.getElementsByTagName('head')[0].appendChild(style);
        this.style = style;
        // print support for RespVis (Webkit only), not supported by Firefox
        // https://bugzilla.mozilla.org/show_bug.cgi?id=774398
        if (window.matchMedia) {
            var mediaQueryList = window.matchMedia('print');
            // non-deprecated version: .addEventListener("change", () => {});
            // deprecated version gives Safari support for now
            mediaQueryList.addListener(function (mql) {
                if (mql.matches) {
                    window.dispatchEvent(new Event('resize'));
                }
            });
        }
    };
    // ---
    // Description: Called whenever the print button is clicked
    // ---
    PrintSettingsComponent.prototype.print = function () {
        this.applyPrintSettings();
        window.print();
    };
    // ---
    // Description: Load print settings from the localStorage
    // ---
    PrintSettingsComponent.prototype.loadSettings = function () {
        try {
            var item = localStorage.getItem("rslidy-print");
        }
        catch (e) {
            console.log(e);
            return;
        }
        if (item === null || item === undefined)
            return;
        var data = JSON.parse(item);
        this.view.querySelector("#rslidy-checkbox-link").checked = data.links;
        this.view.querySelector("#rslidy-checkbox-snum").checked = data.slidenumbers;
        this.view.querySelector("#rslidy-checkbox-frame").checked = data.frame;
        this.applyPrintSettings();
    };
    // ---
    // Description: Save print settings to the localStorage
    // ---
    PrintSettingsComponent.prototype.saveSettings = function () {
        try {
            localStorage.removeItem("rslidy-print");
            localStorage.setItem("rslidy-print", this.generateJSON());
        }
        catch (e) {
            console.log(e);
        }
    };
    // ---
    // Description: Generate a JSON string for the localStorage
    // ---
    PrintSettingsComponent.prototype.generateJSON = function () {
        var data = {
            links: this.view.querySelector("#rslidy-checkbox-link").checked,
            slidenumbers: this.view.querySelector("#rslidy-checkbox-snum").checked,
            frame: this.view.querySelector("#rslidy-checkbox-frame").checked
        };
        return JSON.stringify(data);
    };
    return PrintSettingsComponent;
}());
exports.PrintSettingsComponent = PrintSettingsComponent;
